import http from "../../backend/http.js";

async function getEmployee(id) {
  try {
    const response = await http.get(`crm/employees/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      email: response.data.email,
    };
  } catch (err) {
    throw err;
  }
}

async function updateEmployee(id, employee) {
  try {
    const response = await http.put(`crm/employees/${id}`, employee);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createEmployee(employee) {
  try {
    const response = await http.post("crm/employees", employee);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getEmployees(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `crm/employees?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectEmployee(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/employees/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}


export { getEmployee, updateEmployee, selectEmployee, getEmployees, createEmployee };
